export const LOADING_SET_READY = 'LOADING_SET_READY'
export const LOADING_SET_INC_STATUS = 'LOADING_SET_INC_STATUS'
export const LOADING_FIRST_LOAD = 'LOADING_FIRST_LOAD'
export const LOADING_SET_COOKIE = 'LOADING_SET_COOKIE'
export const LOADING_SET_REAL_LINK = 'LOADING_SET_REAL_LINK'
export const LOADING_SET_SITE_LOADED = 'LOADING_SET_SITE_LOADED'

export const PAGE_ADD_CONTENT = 'PAGE_ADD_CONTENT'
export const PAGE_ADD_MEDIA = 'PAGE_ADD_MEDIA'
export const PAGE_ADD_POST = 'PAGE_ADD_POST'
export const PAGE_ADD_FORM = 'PAGE_ADD_FORM'
export const PAGE_SEND_FORM = 'PAGE_SEND_FORM'
export const PAGE_STATUS_FORM = 'PAGE_STATUS_FORM'
export const PAGE_LIST_CONTENT = 'PAGE_LIST_CONTENT'
export const PAGE_MERGE_LIST_CONTENT = 'PAGE_MERGE_LIST_CONTENT'
export const PAGE_LIST_TAXONOMIES = 'PAGE_LIST_TAXONOMIES'
export const PAGE_SET_NEWSPAGINATION = 'PAGE_SET_NEWSPAGINATION'

export const PAGE_SET_LAYOUT = 'PAGE_SET_LAYOUT'
export const PAGE_SET_TRANSITION = 'PAGE_SET_TRANSITION'
export const PAGE_SET_SHOW = 'PAGE_SET_SHOW'
export const PAGE_SET_CURRENT = 'PAGE_SET_CURRENT'

export const NAV_SET_OPEN = 'NAV_SET_OPEN'
export const NAV_SET_COMPACT = 'NAV_SET_COMPACT'
export const NAV_GET_MAIN = 'NAV_GET_MAIN'
export const NAV_GET_MOBILE = 'NAV_GET_MOBILE'
export const NAV_GET_EXTRA = 'NAV_GET_EXTRA'
export const NAV_GET_GENERIC = 'NAV_GET_GENERIC'

export const MODAL_SET_OPEN = 'MODAL_SET_OPEN'
export const MODAL_SET_IMAGE = 'MODAL_SET_IMAGE'
export const MODAL_SET_TEXT = 'MODAL_SET_TEXT'
export const MODAL_SET_DATA = 'MODAL_SET_DATA'

export const ROUTING_ADD = 'ROUTING_ADD'

export const MEDIA_QUERIES_SET = 'MEDIA_QUERIES_SET'
export const MEDIA_QUERIES_SET_KEY = 'MEDIA_QUERIES_SET_KEY'

export const STRING_GET_ALL = 'STRING_GET_ALL'

export const SHOP_INJECT_PRODUCT = 'SHOP_INJECT_PRODUCT'
export const SHOP_INJECT_CATEGORIES = 'SHOP_INJECT_CATEGORIES'
